import React, { useState } from 'react';
import './Home.css';
import QuoteForm from '../components/QuoteForm';

const Home = () => {
  const [quoteFormOpen, setQuoteFormOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('');

  const products = [
    { id: 1, name: 'BINDING WIRE 18 GAUGE', category: 'wire', image: '/images/products/binding-wire-18.jpeg' },
    { id: 2, name: 'BINDING WIRE - 20 GAUGE', category: 'wire', image: '/images/products/binding-wire-20.jpg' },
    { id: 3, name: 'H B WIRE', category: 'wire', image: '/images/products/hb-wire.jpg' },
    { id: 4, name: 'G I WIRE - COMMERCIAL BRAND', category: 'wire', image: '/images/products/gi-wire-commercial.jpg' },
    { id: 5, name: 'TATA BRAND GI WIRE', category: 'wire', image: '/images/products/gi-wire-tata.jpg' },
    { id: 6, name: 'BARBED WIRE', category: 'fencing', image: '/images/products/barbed-wire.png' },
    { id: 7, name: 'TATA BARBED WIRE', category: 'fencing', image: '/images/products/barbed-wire-tata.png' },
    { id: 8, name: 'WELDMESH - GI', category: 'fencing', image: '/images/products/weldmesh-gi.png' },
    { id: 9, name: 'WELDMESH - MS', category: 'fencing', image: '/images/products/weldmesh-ms.png' },
    { id: 10, name: 'CHAINLINK', category: 'fencing', image: '/images/products/chainlink.png' },
    { id: 11, name: 'GL GC SHEET', category: 'structural', image: '/images/products/gl-gc-sheet.png' },
    { id: 12, name: 'ROOFING SHEET', category: 'structural', image: '/images/products/roofing-sheet.png' },
    { id: 13, name: 'TMT BAR', category: 'structural', image: '/images/products/tmt-bar.png' },
    { id: 14, name: 'STRUCTURAL STEEL', category: 'structural', image: '/images/products/structural-steel.png' }
  ];

  const openQuoteForm = (productName = '') => {
    setSelectedProduct(productName);
    setQuoteFormOpen(true);
  };
  
  const closeQuoteForm = () => {
    setQuoteFormOpen(false);
    setSelectedProduct('');
  };
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>🌟 VARDHAMAN WIRE 🌟</h1>
            <p className="hero-subtitle">✅ Reliable for Wire & Fencing Needs</p>
            <p className="hero-description">
              With 45+ years of experience in wire and steel products, we are your trusted partner 
              for all construction, fencing, and industrial needs.
            </p>
            <div className="hero-buttons">
              <a href="/products" className="btn btn-primary">Our Products</a>
              <button onClick={() => openQuoteForm()} className="btn btn-secondary">📝 Order Online</button>
            </div>
          </div>
        </div>
      </section>

      {/* Products Showcase Section */}
      <section className="products-showcase">
        <div className="container">
          <h2>Our Products</h2>
          <p>Explore our complete range of wire, fencing, and structural steel products</p>
          <div className="products-scroll">
            <div className="products-track">
              {/* Duplicate products array for seamless infinite scroll */}
              {[...products, ...products].map((product, index) => (
                <div 
                  key={`${product.id}-${index}`} 
                  className="product-showcase-card"
                  onClick={() => openQuoteForm(product.name)}
                >
                  <div className="product-showcase-image">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      onError={(e) => {
                        e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="150"%3E%3Crect width="200" height="150" fill="%23f8fafc" stroke="%23e2e8f0" stroke-width="1" rx="8"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" fill="%23637481" font-family="Arial" font-size="14"%3EProduct Image%3C/text%3E%3C/svg%3E';
                      }}
                    />
                  </div>
                  <div className="product-showcase-info">
                    <h4>{product.name}</h4>
                    <button className="showcase-quote-btn">📞 Get Quote</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="products-showcase-cta">
            <a href="/products" className="btn btn-primary">View All Products</a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <h2>Our Product Categories</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🧵</div>
              <h3>Wire Products</h3>
              <p>MS Binding | GI Wire | HB Wire | SS Wire | PC Wire | Cutting Wire | Wire Rod</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">🛡</div>
              <h3>Fencing Products</h3>
              <p>Chainlink | Barbed Wire | Weldmesh | Concertina Coil | 3D Fence | Knotted Fence | PVC Wires</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">🔧</div>
              <h3>Hardware</h3>
              <p>Wire Nails | Roofing Nails | Welding Rod | Hooks (J & L) | Nut | Patti | Fasteners | Chain</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">🏗</div>
              <h3>Structural Steel</h3>
              <p>Channel | Angle | Pipe | Plate | Beam | Colour Sheets</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="container">
          <h2>Why Choose Vardhaman Wire?</h2>
          <div className="features-grid">
            <div className="feature">
              <h4>45+ Years Experience</h4>
              <p>Decades of expertise in wire and steel industry</p>
            </div>
            <div className="feature">
              <h4>Quality Products</h4>
              <p>Premium quality products from trusted brands like TATA, ESSAR, BHUSHAN, JSW</p>
            </div>
            <div className="feature">
              <h4>Nationwide Reach</h4>
              <p>Serving Maharashtra, Goa, Karnataka and nationwide distribution</p>
            </div>
            <div className="feature">
              <h4>One-Stop Solution</h4>
              <p>Complete range of wire, fencing, hardware, and structural steel products</p>
            </div>
            <div className="feature">
              <h4>Reliable Service</h4>
              <p>Strong after-sales support with focus on long-term partnerships</p>
            </div>
            <div className="feature">
              <h4>Eco-Friendly</h4>
              <p>Environmentally conscious and socially responsible business practices</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Get Started?</h2>
            <p>Contact us today for all your wire, fencing, and steel requirements</p>
            <div className="hero-buttons">
              <button onClick={() => openQuoteForm()} className="btn btn-primary">📝 Get Quote Online</button>
              <a href="tel:+919404257415" className="btn btn-secondary">📞 Call Now</a>
            </div>
            <div className="contact-info">
              <div className="contact-item">
                <h4>📍 Location</h4>
                <p>Plot no D-55, Gokulshirgaon MIDC<br />Kolhapur - 416234</p>
              </div>
              <div className="contact-item">
                <h4>📞 Phone</h4>
                <p><a href="tel:+919404257415">+91 9404257415</a></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Form Modal */}
      <QuoteForm 
        isOpen={quoteFormOpen}
        onClose={closeQuoteForm}
        productName={selectedProduct}
      />
    </div>
  );
};

export default Home;